<template>
  <section>
    <div class="row">
      <div class="col-md-6">
        <h3 class="h3">{{ page.name }}</h3>
      </div>
      <div class="col-md-6 text-right">
        <span class="input-group-btn">
          <button
            type="button"
            id="id_create_new_button"
            class="btn btn-primary btn-sm"
            @click="addNewMedia"
          >
            + New Media
          </button>
        </span>
      </div>
    </div>

    <form @submit.prevent="handleFormSubmit">

      <draggable
        v-model="media"
        @start="dragging = true"
        @end="dragging = false"
      >
        <div
          class="row sortable-item"
          v-for="(item, index) in media"
          :key="item.id"
          v-show="!removed.includes(item.id)"
        >
        <template
          v-if="((item.media_groups_id === '' || item.media_groups_id === null || item.media_groups_id === undefined || item.media_groups_id === 1) && smallbanner === 'false') || ((item.media_groups_id === '' || item.media_groups_id === null || item.media_groups_id === undefined || item.media_groups_id > 1) && smallbanner === 'true')"
        >
          <div class="col-md-12 mb-3 drag-row">
            <div class="float-left">
              <template v-if="toggle_hide_show.includes(index)">
                <i class="fa fa-chevron-down chevron" @click="toggleHideShow(index)" />             
              </template>
              <template v-else>
                <i class="fa fa-chevron-right chevron" @click="toggleHideShow(index)" />
              </template> 
              <i class="fa fa-align-justify handle" />
              <img
                style="
                  max-width: 100px;
                  max-height: 30px;
                  display: inline;
                  margin-left: 0.5em;
                  margin-right: 1em;
                "
                :src="`${baseUrl}/${page.name}/desktop/${item.desktop_image_path}`"
              />
              <small><span v-html="item.desktop_title" /></small>
            </div>
            <div>           
              <template v-if="item.id > ''">
                <i class="fa fa-trash delete" @click="removeMedia(item.id)" />
              </template>
            </div>
          </div>

          <div class="col-md-12" v-show="toggle_hide_show.includes(index)">
            <div class="form-row">
              <div class="form-group col-md-1">
                <div class="form-check mt-3">
                  <input
                    class="form-check-input"
                    type="checkbox"
                    v-model="item.is_active"
                  />
                  <label class="form-check-label">Active media</label>
                </div>
              </div>
            </div>
            <div class="form-row">
              <div class="form-group col-md-1">
                <div
                  @click="
                    imageModalShow(
                      page.name,
                      'desktop',
                      item.desktop_image_path
                    )
                  "
                  :style="`width: 100%;
                      height:0;
                      cursor:pointer;
                      padding-top:100%;
                      border-radius: 50%;
                      background-image: url('${baseUrl}/${page.name}/desktop/${item.desktop_image_path}');
                      background-size: cover;`"
                ></div>
              </div>
              <div class="form-group col-md-5 pl-3">
                <label>Desktop Image</label>
                <div class="custom-file">
                  <input
                    name="desktop_image"
                    class="custom-file-input"
                    type="file"
                    @change="chooseFile($event, index)"
                  />
                  <label class="custom-file-label form-control-sm">{{
                    item.title_for_desktop_image
                  }}</label>
                  <div class="form-check mt-3">
                    <input
                      class="form-check-input"
                      type="checkbox"
                      v-model="item.same_image_on_mobile"
                    />
                    <label class="form-check-label">Same image on mobile</label>
                  </div>
                </div>
              </div>
              <div class="form-group col-md-6">
                <label>Desktop Title</label>
                <input
                  type="text"
                  class="form-control"
                  placeholder="Title for Desktop"
                  v-model="item.desktop_title"
                />
                <div class="form-check mt-3">
                  <input
                    class="form-check-input"
                    type="checkbox"
                    v-model="item.same_title_on_mobile"
                  />
                  <label class="form-check-label">Same title on mobile</label>
                </div>
              </div>
            </div>
            <div class="form-row">
              <div class="form-group col-md-1">
                <div
                  @click="
                    imageModalShow(page.name, 'mobile', item.mobile_image_path)
                  "
                  :style="`width: 100%;
                      height:0;
                      cursor:pointer;
                      padding-top:100%;
                      border-radius: 50%;
                      background-image: url('${baseUrl}/${page.name}/mobile/${item.mobile_image_path}');
                      background-size: cover;`"
                  v-if="!item.same_image_on_mobile"
                ></div>
              </div>
              <div class="form-group col-md-5 pl-3">
                <span v-if="!item.same_image_on_mobile">
                  <label>Mobile Image</label>
                  <div class="custom-file">
                    <input
                      :id="`import_${index}`"
                      name="mobile_image"
                      class="custom-file-input"
                      type="file"
                      @change="chooseFile($event, index)"
                    />
                    <label class="custom-file-label form-control-sm">{{
                      item.title_for_mobile_image
                    }}</label>
                  </div>
                </span>
              </div>
              <div
                class="form-group col-md-6"
                v-if="!item.same_title_on_mobile"
              >
                <label>Mobile Title</label>
                <input
                  type="text"
                  class="form-control"
                  placeholder="Title for Mobile"
                  v-model="item.mobile_title"
                />
              </div>
            </div>
            <div class="form-row">
              <div class="form-group col-md-6">
                <label>Destination URL</label>
                <input
                  type="text"
                  class="form-control"
                  placeholder="Destination URL"
                  v-model="item.destination_url"
                />
              </div>
              <div class="form-group col-md-2">
                <label for="media_groups_id">Media Group</label>
                <select class="form-control" v-model="item.media_groups_id">
                  <option value="">---</option>
                  <option
                    v-for="(group, group_id) in media_groups"
                    :key="group_id"
                    :value="group_id"
                  >
                    {{ group }}
                  </option>
                </select>
              </div>
            </div>
            <div class="form-row">
              <div class="form-group col-md-6">
                <label>Enable date:</label>

                <div class="form-check pl-0">
                  <date-picker
                    type="datetime"
                    v-model="range_date[index]"
                    :id="'date_' + item.id"
                    :range="is_range_date[index]"
                    range-separator=" - "
                    time-title-format="YYYY-MM-DD"
                    value-type="timestamp"
                  ></date-picker>
                </div>
                <div class="form-check">
                  <input
                    class="form-check-input"
                    type="checkbox"
                    v-model="is_range_date[index]"
                    :id="is_range_date[index]"
                    v-on:change="isRangeChange($event, index)"
                  />
                  <label class="form-check-label">with end date</label>
                </div>
              </div>
            </div>
            <div class="form-row">
              <div class="form-group col-md-6">
                <label>Inline CSS</label>
                <input
                  type="text"
                  class="form-control"
                  placeholder="Custom CSS"
                  v-model="item.inline_css"
                />
              </div>
            </div>
          </div>
        </template>       
          <!-- close col-md-12 -->
        </div>
        <!-- close row -->
      </draggable>

      <div class="row">
        <div class="col-md-12 text-right">
          <button class="btn btn-primary btn-sm btn-icon-splitfloat-right">
            {{ type }}
          </button>
        </div>
      </div>
    </form>
  </section>
</template>

<script>
import MediaRequest from "@/components/ApiRequester/PageMedia";
import Draggable from "vuedraggable";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";

export default {
  name: "MediaPageForm",
  props: {
    type: {
      required: 1,
      type: String,
      validator: (val) => ["Create", "Update"].includes(val),
    },
    item: {
      required: 1,
      type: String,
    },
  },
  components: {
    Draggable,
    DatePicker,
  },
  data: () => ({
    page: {},
    media: [],
    media_groups: {},
    payload: [],
    dragging: false,
    removed: [],
    is_range_date: [],
    range_date: [],
    smallbanner: false,
    toggle_hide_show: [],
  }),
  computed: {
    baseUrl() {
      return process.env.VUE_APP_MAXTOP_IMAGE_URL;
    },
  },
  mounted() {
    this.smallbanner = this.$route.params.smallbanner;
  },
  created() {
    document.getElementById("loader").classList.add("active");
    const ApiRequest = new MediaRequest();

    ApiRequest.all({ page_id: this.$props.item }).then((response) => {
      const { data } = response;
      this.page = data.page;
      this.media = data.media;
      this.media_groups = data.media_groups;
      this.media.forEach((obj, index) => {
        this.range_date[index] = obj.start_date;
        this.is_range_date[index] = false;
        this.toggle_hide_show[index] = false;
        if (obj.start_date > "") {
          this.range_date[index] = obj.start_date * 1000;
        }
        if (obj.end_date > "") {
          this.range_date[index] = [
            this.range_date[index],
            obj.end_date * 1000,
          ];
          this.is_range_date[index] = true;
        }
        Object.assign(obj, {
          desktop_title: obj.desktop_title === null ? "" : obj.desktop_title,
          mobile_title: obj.mobile_title === null ? "" : obj.mobile_title,
          destination_url:
            obj.destination_url === null ? "" : obj.destination_url,
          title_for_desktop_image: [null, ""].includes(obj.desktop_image_path)
            ? "Choose file"
            : obj.desktop_image_path,
          title_for_mobile_image: [null, ""].includes(obj.mobile_image_path)
            ? "Choose file"
            : obj.mobile_image_path,
          inline_css: obj.inline_css === null ? "" : obj.inline_css,
          sorting_order: obj.sorting_order === null ? "" : obj.sorting_order,
          media_groups_id:
            obj.media_groups_id === null ? "" : obj.media_groups_id,
          remove: 0,
        });
        this.payload.push(new FormData());        
      });
      document.getElementById("loader").classList.remove("active");
    });
  },
  methods: {
    isRangeChange(evt, index) {
      if (this.is_range_date[index] === true) {
        this.range_date[index] = [
          this.range_date[index],
          this.range_date[index] + 90 * 60 * 60 * 24 * 1000,
        ];
      } else {
        this.range_date[index] = this.range_date[index][0];
      }
    },
    chooseFile(evt, index) {
      const { name, files } = evt.target;

      switch (name) {
        case "desktop_image":
          this.media[index].title_for_desktop_image = files[0].name;
          break;
        case "mobile_image":
          this.media[index].title_for_mobile_image = files[0].name;
          break;
      }

      this.$forceUpdate();

      this.payload[index].append(name, files[0], files[0].name);
    },

    removeMedia(id) {
      this.removed.push(id);
    },

    toggleHideShow(id) {
      if (this.toggle_hide_show.includes(id)) {
        const index = this.toggle_hide_show.indexOf(id);
        if (index > -1) {
          this.toggle_hide_show.splice(index, 1);
        }
      } else {
        this.toggle_hide_show.push(id);
      }
    },

    addNewMedia() {
      let group = 1;
      if (this.smallbanner === 'true') {
        group = 2;
      }
      this.media.unshift({
        id: "",
        same_image_on_mobile: true,
        same_title_on_mobile: true,
        desktop_title: "",
        mobile_title: "",
        destination_url: "",
        media_groups_id: group,
        is_active: true,
      });
      this.payload.unshift(new FormData());
      this.range_date.unshift(new Date().getTime());
      this.is_range_date.unshift(false);
      this.toggle_hide_show.unshift(false);
    },

    async imageModalShow(page_name, type, desktop_image_path) {
      const title = page_name + "/" + type + "/" + desktop_image_path;
      const image = this.baseUrl + "/" + title;
      this.$emit("image-show", title, image);
    },

    async handleFormSubmit() {
      const promises = [];
      const ApiRequester = new MediaRequest();

      this.media.forEach((item, index) => {
        if (this.payload[index].get("mobile_image") === null) {
          this.payload[index].append("mobile_image", null);
        }

        if (this.payload[index].get("desktop_image") === null) {
          this.payload[index].append("desktop_image", null);
        }

        const {
          id,
          same_image_on_mobile,
          desktop_title,
          same_title_on_mobile,
          mobile_title,
          destination_url,
          media_groups_id,
          is_active,
        } = item;

        let start_date = null;
        let end_date = null;

        if (this.is_range_date[index] === true) {
          start_date = this.range_date[index][0] / 1000;
          end_date = this.range_date[index][1] / 1000;
        } else {
          start_date = this.range_date[index] / 1000;
        }

        this.payload[index].append("id", id === null ? "" : id);
        this.payload[index].append(
          "desktop_title",
          desktop_title === null ? "" : desktop_title
        );
        this.payload[index].append(
          "same_image_on_mobile",
          same_image_on_mobile
        );
        this.payload[index].append(
          "same_title_on_mobile",
          same_title_on_mobile
        );
        this.payload[index].append(
          "mobile_title",
          mobile_title === null ? "" : mobile_title
        );
        this.payload[index].append(
          "destination_url",
          destination_url === null ? "" : destination_url
        );
        this.payload[index].append(
          "media_groups_id",
          media_groups_id === null ? "" : media_groups_id
        );

        this.payload[index].append("is_active", is_active);

        this.payload[index].append("sorting_order", index * 5);
        this.payload[index].append("remove", this.removed.includes(item.id));
        this.payload[index].append("start_date", start_date);
        this.payload[index].append("end_date", end_date);
        this.payload[index].append("_method", "PUT");

        promises.push(
          ApiRequester.update({
            id: this.page.id,
            data: this.payload[index],
          })
        );
      });

      document.getElementById("loader").classList.add("active");

      const errors = [];

      await Promise.all(promises).catch((error) => {
        errors.push(error.response.data.error);
      });

      document.getElementById("loader").classList.remove("active");
      this.$emit("submit", errors);
    },
  },
};
</script>

<style lang="scss" scoped>
.custom-file-label {
  overflow: hidden;
}
.b-list-group-item.active {
  opacity: 0.5;
}

.b-list-group-item.drop-target {
  border: 2px dashed #333;
}

.b-list-group-item.placeholder {
  height: 40px;
  background: #f2f2f2;
  border: 1px dashed #ccc;
}

.chevron {
  float: left;
  padding-top: 8px;
  padding-bottom: 8px;
  margin-right: 16px;
}
.handle {
  float: left;
  padding-top: 8px;
  padding-right: 8px;
  padding-bottom: 8px;
}
.delete {
  float: right;
  padding-top: 8px;
  padding-bottom: 8px;
}

.drag-row {
  line-height: 32px;
  background: #f4f4f4;
}
.drag-row:hover {
  background: #e4e4e4;
}
</style>
